import LegalPage from "@/pages/legal/LegalPage";

export default function Refund() {
  return (
    <LegalPage
      testid="refund-page"
      draft
      title="Refund Policy"
      updated="2026-06-01"
      intro="Trifit.XPS is sold as prepaid credits that are consumed when AI-assisted work is performed. This policy explains when a refund is available."
      sections={[
        { h: "Unused credits", p: [
          "If you have bought a credit pack and have not consumed any of it, you may request a full refund within seven days of payment.",
          "Where part of a pack has been consumed, we refund the unused balance on a pro-rata basis, less any payment-gateway fee that cannot be recovered.",
        ]},
        { h: "Failed or duplicated work", p: [
          "If a credit-charged action fails because of a fault on our side, the credits are returned to your balance automatically. If they are not, contact us and we will restore them.",
          "Duplicate charges for the same file or the same action are always refunded in credits.",
        ]},
        { h: "What is not refundable", p: [
          "Credits already consumed by completed analysis, transcription, reports or simulations are not refundable, because the compute has been performed.",
          "Dissatisfaction with a model output is not on its own grounds for a refund, since outputs are best-effort estimates and are presented as such. We will always review specific cases.",
        ]},
        { h: "How to request a refund", p: [
          "Write to billing@trifitindia.com from the email address on the account, with the order reference from your billing history. We aim to respond within three working days and to settle approved refunds to the original payment method within seven to ten working days.",
        ]},
        { h: "Payment processing", p: [
          "Payments are processed by Razorpay. We do not store card details. Refunds are issued through the same channel as the original payment.",
        ]},
      ]}
    />
  );
}
